"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@dbi-tools/ui-kit");

var _list = require("@dbi-tools/ui-kit/lib/list");

var _collapsingNav = require("@dbi-tools/ui-kit/lib/ecommerce/components/collapsing-nav");

var _const = require("@dbi-tools/ui-kit/lib/ecommerce/components/collapsing-nav/const");

var _triangleLeft = _interopRequireDefault(require("@dbi-tools/ui-kit/lib/icons/triangle-left"));

var _themeOptions = require("../../helpers/theme-options");

var _useMedia = require("../../hooks/use-media");

var _const2 = require("../../const");

var _mapping = require("../../mapping");

var _layoutItem = _interopRequireDefault(require("../../layout/layout-item"));

var _const3 = require("./const");

var _resourcesColumnList = require("./resources-column-list.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ResourcesColumnListUi = function ResourcesColumnListUi(_ref) {
  var componentID = _ref.id,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? _themeOptions.ThemeVariants.WHITE : _ref$theme,
      items = _ref.items,
      _ref$itemsOrder = _ref.itemsOrder,
      itemsOrder = _ref$itemsOrder === void 0 ? [] : _ref$itemsOrder,
      fluid = _ref.fluid,
      children = _ref.children,
      containerProps = _ref.containerProps,
      _ref$isInStoryBook = _ref.isInStoryBook,
      isInStoryBook = _ref$isInStoryBook === void 0 ? false : _ref$isInStoryBook,
      removeTopPadding = _ref.removeTopPadding,
      removeBottomPadding = _ref.removeBottomPadding,
      routerLink = _ref.routerLink,
      pathnameCustom = _ref.pathnameCustom,
      pathname = _ref.pathname,
      sidebarLink = _ref.sidebarLink,
      sidebarLinkText = _ref.sidebarLinkText;
  var titleType = 'aem-integration/components/title';
  var isTablet = (0, _useMedia.useMedia)(_const2.Breakpoints.TABLET);
  var isMobile = (0, _useMedia.useMedia)(_const2.Breakpoints.MOBILE);
  var isMobileDevice = isTablet || isMobile;
  var path = pathnameCustom || pathname;

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      activeLink = _useState2[0],
      setActiveLink = _useState2[1];

  var container = (0, _react.useRef)();

  var getItems = function getItems(obj) {
    var _obj$Items = obj[':items'],
        items = _obj$Items === void 0 ? {} : _obj$Items,
        _obj$ItemsOrder = obj[':itemsOrder'],
        itemsOrder = _obj$ItemsOrder === void 0 ? [] : _obj$ItemsOrder;
    return itemsOrder.map(function (key) {
      return items[key];
    });
  };

  var getIDs = function getIDs() {
    var idArr = [];
    itemsOrder.map(function (type) {
      var arr = getItems(items[type]);
      arr.map(function (_ref2, i) {
        var _ref2$id = _ref2.id,
            id = _ref2$id === void 0 ? '' : _ref2$id,
            _ref2$Type = _ref2[':type'],
            type = _ref2$Type === void 0 ? '' : _ref2$Type;
        var prevEl = i > 0 ? arr[i - 1] : arr[i];

        if (type !== titleType) {
          idArr.push({
            titleId: prevEl[':type'] === titleType ? prevEl.id : null,
            contentId: id
          });
        }
      });
    });
    return idArr;
  };

  var handleScrollToSection = function handleScrollToSection(id) {
    var element = document.getElementById(id);
    if (!element) return;
    var currentScroll = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
    var scrollOffset = isMobileDevice ? _const3.SCROLL_OFFSET_MOBILE : _const3.SCROLL_OFFSET;
    var scrollElement = document.scrollingElement || document.documentElement;
    scrollElement.scrollTop = element.getBoundingClientRect().top + currentScroll - scrollOffset;
  };

  var scrollHandler = function scrollHandler() {
    var iDs = getIDs();
    iDs.map(function (el) {
      var titleId = el.titleId,
          contentId = el.contentId;
      var title = titleId && document.getElementById(titleId);
      var content = contentId && document.getElementById(contentId);
      if (!title || !content) return;
      var sectionHeight = content.offsetHeight;
      var sectionTop = content.offsetTop - 200;

      if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
        setActiveLink(titleId);
      }
    });
  };

  (0, _react.useEffect)(function () {
    scrollHandler();
    var id = location.hash.substring(1);
    id && handleScrollToSection(id);
  }, [location.hash, location.pathname]);
  (0, _react.useEffect)(function () {
    window.addEventListener('scroll', scrollHandler);
    return function () {
      window.removeEventListener('scroll', scrollHandler);
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (container.current) {
      // @ts-ignore
      container.current.parentElement.style.overflow = 'initial';
    }
  }, []);
  var data = itemsOrder.map(function (type, index) {
    var container = items[type];
    var routes = getItems(container).filter(function (el) {
      return el[':type'] === titleType;
    });
    if (!routes.length) return {
      title: container.title || "Category ".concat(index + 1),
      links: [{
        name: container.title || "Category ".concat(index + 1),
        href: "".concat(path, "/").concat(container.id),
        isActive: location.href.endsWith(container.id),
        onClick: function onClick() {
          return handleScrollToSection(container.id);
        }
      }]
    };
    return {
      headline: container.title || "Category ".concat(index + 1),
      links: routes.map(function (_ref3) {
        var children = _ref3.children,
            id = _ref3.id,
            _ref3$linkURL = _ref3.linkURL,
            linkURL = _ref3$linkURL === void 0 ? '' : _ref3$linkURL;
        return {
          name: children,
          href: linkURL || "".concat(path, "/").concat(container.id, "#").concat(id),
          isActive: id === location.hash.substring(1),
          onClick: function onClick() {
            return handleScrollToSection(id);
          }
        };
      })
    };
  });

  var getMobNavTheme = function getMobNavTheme(theme) {
    switch (theme) {
      case _themeOptions.ThemeVariants.WHITE:
        return _const.CollapsingNavThemeVariants.WHITE;

      case _themeOptions.ThemeVariants.SEASHELL:
        return _const.CollapsingNavThemeVariants.SEASHELL;

      case _themeOptions.ThemeVariants.MOCASSIN:
        return _const.CollapsingNavThemeVariants.MOCASSIN;

      default:
        return _const.CollapsingNavThemeVariants.DEFAULT;
    }
  };

  var active = data.findIndex(function (item) {
    return item.links.find(function (link) {
      return link.isActive;
    });
  });
  var isNeededDefaultTitle = active === -1 && !data[0].headline || active > -1 && !data[active].headline;
  return /*#__PURE__*/_react.default.createElement(_resourcesColumnList.ContainerStyled, {
    removeTopPadding: removeTopPadding,
    removeBottomPadding: removeBottomPadding,
    "data-test": _const2.TestType.COMPONENT,
    "data-test-id": _const2.TestValue.AEM_RESOURCES_COLUMN_LINKS,
    ref: container,
    id: componentID
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Row, null, /*#__PURE__*/_react.default.createElement(_resourcesColumnList.MenuColStyled, {
    lg: 3
  }, /*#__PURE__*/_react.default.createElement(_resourcesColumnList.MenuWrapStyled, null, sidebarLink && /*#__PURE__*/_react.default.createElement(_resourcesColumnList.SidebarLinkStyled, null, /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
    as: "a",
    href: sidebarLink,
    variant: "link",
    color: "gray500",
    pb: 9
  }, /*#__PURE__*/_react.default.createElement(_triangleLeft.default, {
    measure: 8,
    color: "gray500",
    mr: 5
  }), sidebarLinkText)), isTablet || isMobile ? /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
    pb: 15
  }, /*#__PURE__*/_react.default.createElement(_collapsingNav.CollapsingNav, {
    title: isNeededDefaultTitle && "".concat(_const3.JUMP_TO, ":"),
    items: data,
    theme: getMobNavTheme(theme),
    active: active,
    routerLink: routerLink,
    isAem: true
  })) : /*#__PURE__*/_react.default.createElement(_resourcesColumnList.ColumnLinksStyled, {
    theme: theme,
    p: {
      xs: [15],
      lg: [30]
    }
  }, /*#__PURE__*/_react.default.createElement(_list.List, {
    color: "gray800",
    m: [0],
    measure: "md",
    p: [0]
  }, itemsOrder.map(function (type, i) {
    var container = items[type];
    var categoryID = container.id,
        title = container.title;
    return /*#__PURE__*/_react.default.createElement(_resourcesColumnList.CategoryListItemStyled, {
      key: i
    }, /*#__PURE__*/_react.default.createElement(_resourcesColumnList.MenuCategoryStyled, {
      as: routerLink || 'a',
      to: "".concat(path, "/").concat(categoryID),
      style: {
        color: _uiKit.Colors.primaryDark
      }
    }, title || "Category ".concat(i + 1)), itemsOrder.length > 0 && /*#__PURE__*/_react.default.createElement(_resourcesColumnList.SubCategoryList, {
      isCollapsed: false,
      m: [7.5, 0, 0, 0],
      measure: "md",
      p: [0]
    }, getItems(container).map(function (_ref4, i) {
      var _ref4$Type = _ref4[':type'],
          type = _ref4$Type === void 0 ? '' : _ref4$Type,
          _ref4$linkURL = _ref4.linkURL,
          linkURL = _ref4$linkURL === void 0 ? '' : _ref4$linkURL,
          _ref4$id = _ref4.id,
          id = _ref4$id === void 0 ? '' : _ref4$id,
          _ref4$children = _ref4.children,
          children = _ref4$children === void 0 ? '' : _ref4$children;
      return type === titleType && /*#__PURE__*/_react.default.createElement(_list.List.Item, {
        key: i
      }, /*#__PURE__*/_react.default.createElement(_resourcesColumnList.MenuButtonStyled, {
        as: routerLink || 'a',
        to: linkURL || "".concat(path, "/").concat(categoryID, "#").concat(id),
        style: {
          fontWeight: "".concat(id === activeLink ? 'bold' : '300')
        }
      }, children));
    })));
  }))))), /*#__PURE__*/_react.default.createElement(_resourcesColumnList.ContentColStyled, _extends({
    lg: 9
  }, _objectSpread({
    fluid: fluid
  }, containerProps), {
    withAsideButton: !!sidebarLink
  }), children && _react.default.Children.map(children, function (item, index) {
    var _item$props;

    var contentArr = getItems(item.props);
    var isInEditor = item === null || item === void 0 ? void 0 : (_item$props = item.props) === null || _item$props === void 0 ? void 0 : _item$props.isInEditor;
    return /*#__PURE__*/_react.default.createElement(_resourcesColumnList.CategoryStyled, {
      key: "row_".concat(index)
    }, item.props.showCategoryName && item.props.title && /*#__PURE__*/_react.default.createElement(_uiKit.Heading, {
      as: "h2",
      measure: isMobile || isTablet ? 'h3' : 'h2',
      id: item.props.id,
      mb: 15
    }, item.props.title), isInEditor ? item : contentArr.map(function (el, i) {
      var isLastItem = index === itemsOrder.length - 1 && i === contentArr.length - 1;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
        key: i
      }, /*#__PURE__*/_react.default.createElement(_layoutItem.default, _extends({
        id: el.id,
        containerCount: index
      }, el)), el[':type'] !== titleType && /*#__PURE__*/_react.default.createElement(_resourcesColumnList.ToTopButtonStyled, {
        color: "primaryDark",
        measure: "md",
        type: "button",
        uppercase: false,
        variant: "link",
        onClick: function onClick() {
          return handleScrollToSection(componentID);
        }
      }, _const3.RETURN_TO_TOP), el[':type'] !== titleType && !isLastItem && /*#__PURE__*/_react.default.createElement(_resourcesColumnList.LineStyled, null));
    }));
  }), isInStoryBook && itemsOrder.map(function (key, index) {
    if (!_mapping.AemMapComponent.hasOwnProperty(items[key][':type'])) {
      return;
    }

    var contentArr = getItems(items[key]);
    return /*#__PURE__*/_react.default.createElement(_resourcesColumnList.CategoryStyled, {
      key: "row_".concat(index)
    }, items[key].showCategoryName && /*#__PURE__*/_react.default.createElement(_uiKit.Heading, {
      as: "h2",
      measure: isMobile || isTablet ? 'h3' : 'h2',
      id: items[key].id,
      mb: 15
    }, items[key].title), contentArr.map(function (el, i) {
      var isLastItem = index === itemsOrder.length - 1 && i === contentArr.length - 1;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
        key: i
      }, /*#__PURE__*/_react.default.createElement(_layoutItem.default, _extends({
        containerCount: index
      }, el)), el[':type'] !== titleType && /*#__PURE__*/_react.default.createElement(_resourcesColumnList.ToTopButtonStyled, {
        color: "primaryDark",
        measure: "md",
        type: "button",
        uppercase: false,
        variant: "link",
        onClick: function onClick() {
          return handleScrollToSection(componentID);
        }
      }, _const3.RETURN_TO_TOP), el[':type'] !== titleType && !isLastItem && /*#__PURE__*/_react.default.createElement(_resourcesColumnList.LineStyled, null));
    }));
  }))));
};

var _default = ResourcesColumnListUi;
exports.default = _default;